/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProviderListItem,
    ProviderListItemFromJSON,
    ProviderListItemFromJSONTyped,
    ProviderListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderListItemPaginationWrapper
 */
export interface ProviderListItemPaginationWrapper {
    /**
     * 
     * @type {Array<ProviderListItem>}
     * @memberof ProviderListItemPaginationWrapper
     */
    items?: Array<ProviderListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof ProviderListItemPaginationWrapper
     */
    totalItems?: number;
}

export function ProviderListItemPaginationWrapperFromJSON(json: any): ProviderListItemPaginationWrapper {
    return ProviderListItemPaginationWrapperFromJSONTyped(json, false);
}

export function ProviderListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(ProviderListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function ProviderListItemPaginationWrapperToJSON(value?: ProviderListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(ProviderListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


